export default {
  heart: require('@fortawesome/pro-light-svg-icons/faHeart').definition,
  'eye-slash': require('@fortawesome/pro-light-svg-icons/faEyeSlash').definition
}
